import script from "./HeaderUzafoundationMobileNavigation.vue?vue&type=script&setup=true&lang=js"
export * from "./HeaderUzafoundationMobileNavigation.vue?vue&type=script&setup=true&lang=js"

import "./HeaderUzafoundationMobileNavigation.vue?vue&type=style&index=0&id=2ce9e8be&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2ce9e8be"]])

export default __exports__